import { AppConstants } from "./constants";

export enum ReportTypes {
  Learners = 1,
  LearnersActivity = 2,
  OverallInitialAssessmentResult = 3,
  AppNumberInitialAssessmentBreakdown = 4,
  CommEnglishInitialAssessmentBreakdown = 5,
  CommWelshInitialAssessmentBreakdown = 6,
  DigLitInitialAssessmentBreakdown = 7,
  AppNumberDistanceTravelBySkill = 9,
  CommEnglishDistanceTravelBySkill = 10,
  CommWelshDistanceTravelBySkill = 11,
  DigLitDistanceTravelBySkill = 12,
  AppNumberDistanceTravel = 14,
  CommEnglishDistanceTravel = 15,
  CommWelshDistanceTravel = 16,
  DigLitDistanceTravel = 17,
  OverallScreenerResult = 26,
  DigLitSelfAssessDistanceTravel = 27,
  DigLitSelfAssessDistanceTravelBySkill = 28,
  LearnerStatisticsAllCourses = 19,
  LearnerStatisticsSingleCourse = 20,
  ScreenerStatisticsAllCourses = 21,
  ScreenerStatisticsSingleCourse = 22,
  InitialAssessmentStatisticsAllCourses = 24,
  InitialAssessmentStatisticsSingleCourse = 25
}

export interface AggregateReportTypes {
  path: string;
  name: string;
  id: number;
  resetPath: string;
  lengthPath: string;
  resetTable: string;
}

export const AggregateReportTypeList: AggregateReportTypes[] = [
  {
    path: "learner-statistics-all-courses",
    name: AppConstants.LEARNER_STATISTICS_ALL_COURSES_RT,
    id: ReportTypes.LearnerStatisticsAllCourses,
    resetPath: "Reports/resetlearnerstatisticsallcoursesreporttablelist",
    lengthPath: "Reports/learnerstatisticsallcoursesreporttablelistlength",
    resetTable: "resetlearnerstatisticsallcoursesreporttablelist"
  },
  {
    path: "learner-statistics-single-course",
    name: AppConstants.LEARNER_STATISTICS_SINGLE_COURSE_RT,
    id: ReportTypes.LearnerStatisticsSingleCourse,
    resetPath: "Reports/resetlearnerstatisticssinglecoursereporttablelist",
    lengthPath: "Reports/learnerstatisticssinglecoursereporttablelistlength",
    resetTable: "resetlearnerstatisticssinglecoursereporttablelist"
  },
  {
    path: "screener-statistics-all-courses",
    name: AppConstants.SCREENER_STATISTICS_ALL_COURSES_RT,
    id: ReportTypes.ScreenerStatisticsAllCourses,
    resetPath: "Reports/resetlearnerstatisticsallcoursesreporttablelist",
    lengthPath: "Reports/screenerstatisticsallcoursesreporttablelistlength",
    resetTable: "resetlearnerstatisticssinglecoursereporttablelist"
  },
  {
    path: "screener-statistics-single-course",
    name: AppConstants.SCREENER_STATISTICS_SINGLE_COURSE_RT,
    id: ReportTypes.ScreenerStatisticsSingleCourse,
    resetPath: "Reports/resetscreenerstatisticssinglecoursereporttablelist",
    lengthPath: "Reports/screenerstatisticssinglecoursereporttablelistlength",
    resetTable: "resetscreenerstatisticssinglecoursereporttablelist"
  },
  {
    path: "initial-assessment-statistics-all-courses",
    name: AppConstants.INITIAL_ASSESSMENT_STATISTICS_ALL_COURSES_RT,
    id: ReportTypes.InitialAssessmentStatisticsAllCourses,
    resetPath: "Reports/resetinitialAssessmentstatisticsallcoursesreporttablelist",
    lengthPath: "Reports/initialAssessmentstatisticsallcoursesreporttablelistlength",
    resetTable: "resetinitialAssessmentstatisticsallcoursesreporttablelist"
  },
  {
    path: "initial-assessment-statistics-single-course",
    name: AppConstants.INITIAL_ASSESSMENT_STATISTICS_SINGLE_COURSE_RT,
    id: ReportTypes.InitialAssessmentStatisticsSingleCourse,
    resetPath: "Reports/resetinitialAssessmentstatisticssinglecoursereporttablelist",
    lengthPath: "Reports/initialAssessmentstatisticssinglecoursereporttablelistlength",
    resetTable: "resetinitialAssessmentstatisticssinglecoursereporttablelist"
  }
];

